<div mat-dialog-title>
    <div *ngIf="warehouse?.warehouse_ID" i18n>Edit Warehouse</div>
    <div *ngIf="!warehouse?.warehouse_ID" i18n>Add Warehouse</div>
</div>
<mat-dialog-content *ngIf="warehouse">
    <div class="form-inline mb-2">
        <div *ngIf="warehouse.warehouse_ID" i18n>Make the necessary changes on the form below then click Submit</div>
        <div *ngIf="!warehouse.warehouse_ID" i18n>To add a new Warehouse, complete the form below then click Submit.</div>
        <div class="float-right warning col-sm-4" i18n>* Required Information</div>
    </div>
    <div>
        <form #form="ngForm">
            <div class="form-group form-inline">
                <label class="pr-2" for="name"><span class="warning">* </span><span i18n>Warehouse Name</span></label>
                <div>
                    <input id="name" name="name" class="form-control" [(ngModel)]="warehouse.warehouse_Name"
                           required #name="ngModel"
                           [class.field-error]="form.submitted && name.invalid">
                    <div [hidden]="!form.submitted || name.valid"
                         class="alert alert-danger" i18n>
                        Warehouse Name is invalid
                    </div>
                </div>
            </div>
            <div class="form-group form-inline">
                <label class="pr-2" for="address"><span class="warning">* </span><span i18n>Address</span></label>
                <div>
                    <input type="text" id="address" name="address" class="form-control" [(ngModel)]="warehouse.warehouse_Address"
                           required #address="ngModel"
                           [class.field-error]="form.submitted && address.invalid">
                    <div [hidden]="!form.submitted || address.valid"
                         class="alert alert-danger" i18n>
                        Address is invalid
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-12 form-inline">
                    <div class="control-wrapper">
                        <label class="col-form-label" for="city"><span class="warning">* </span><span i18n>City</span></label>
                        <input id="city" name="city"
                               required
                               placeholder="City"
                               i18n-placeholder
                               class="form-control"
                               [(ngModel)]="warehouse.warehouse_City"
                               #city="ngModel"
                               [class.field-error]="form.submitted && city.invalid">
                        <div [hidden]="!form.submitted || city.valid"
                             class="alert alert-danger" i18n>
                            City is invalid
                        </div>
                    </div>
                    <div class="control-wrapper">
                        <label class="col-form-label" for="state"><span class="warning">* </span><span i18n>State</span></label>
                        <select [(ngModel)]="warehouse.warehouse_State" name="state" id="state" class="form-control select-bidit" required #state="ngModel"
                                [class.field-error]="form.submitted && state.invalid">
                            <option value="" selected="">-</option>
                            <option *ngFor="let state of states;  let i=index" [(ngValue)]="states[i]">{{state}}</option>
                        </select>
                        <div [hidden]="!form.submitted || state.valid"
                             class="alert alert-danger" i18n>
                            State is invalid
                        </div>
                    </div>
                    <div class="control-wrapper">
                        <label class="col-form-label" for="postal"><span class="warning">* </span><span i18n>Zip</span></label>
                        <input id="postal" name="postal"
                               required
                               placeholder="Zip"
                               i18n-placeholder
                               class="form-control"
                               [(ngModel)]="warehouse.warehouse_Postal"
                               #postal="ngModel" />
                        <div [hidden]="!form.submitted || postal.valid"
                             class="alert alert-danger" i18n>
                            Enter a valid zip code
                        </div>
                    </div>
                </div>
            </div>            
            <div class="mt-3">
                <div [hidden]="!form.submitted || form.valid"
                     class="alert alert-danger" i18n>
                    Validation issues encountered.  Please review your entered information.
                </div>
            </div>
            <div align="end">
                <div *ngIf="!isRequesting">
                    <button type="button" (click)="saveWarehouse(form, false)" [disabled]="isRequesting" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
                    <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
                </div>
                <app-spinner [isRunning]="isRequesting"></app-spinner>
            </div>

        </form>
    </div>
</mat-dialog-content>
